import { Component, Input, OnChanges, OnDestroy } from "@angular/core";

import { BmCardsCalcService } from "./service/bm-cards-calc.service";
import { BmAnalyticsCalculationsService } from "./service/bm-analytics-calculations.service";
import { BmAnalyticsChartsService } from "./service/bm-analytics-charts.service";
import { Subject } from "rxjs";
import { BmFundActualAnalytics } from "../../pojo/bm-classes";
import { BudgetModelFormGroup } from "../../pojo/bm-form";
import { BmAnalyticsCard,
  BmAnalyticsChartsOptions,
  BmBarChartsTypes,
  BmSelectedChart } from "../../pojo/bm-analytics-classes";
import {ReactiveFormsModule} from "@angular/forms";
import {BmAnalyticsCardComponent} from "../analytics-card/bm-analytics-card.component";
import {ButtonComponent} from "../../../../shared/component/buttons/button.component";
import {BaseBarChartComponent} from "../../../../charts/base-bar-chart/base-bar-chart.component";
import {BasePieChartComponent} from "../../../../charts/base-pie-chart/base-pie-chart.component";


@Component({
  selector: 'app-bm-analytics',
  templateUrl: './bm-analytics.component.html',
  styleUrls: ['./bm-analytics.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    BmAnalyticsCardComponent,
    ButtonComponent,
    BaseBarChartComponent,
    BasePieChartComponent
]
})
export class BmAnalyticsComponent implements OnChanges, OnDestroy {
  private _destroyStream: Subject<void> = new Subject<void>();
  @Input({ required: true }) budgetForm: BudgetModelFormGroup;

  analyticsCards: BmAnalyticsCard[] = [];
  chartOptions: BmAnalyticsChartsOptions;
  selected = new BmSelectedChart();
  BmBarChartsTypes = BmBarChartsTypes;


  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  ngOnChanges(): void {
    if (this.budgetForm) {
      BmAnalyticsCalculationsService.updateAnalyticsForm(this.budgetForm);
      this.calculateAnalyticsCards();
      this.prepareChartsOptions();
    }
  }

  /**
   * Calculate analytics cards based on current analytics data
   */
  private calculateAnalyticsCards(): void {
    const budgetData = this.budgetForm.value.analyticsData.periodBudgetData as BmFundActualAnalytics;
    this.analyticsCards = BmCardsCalcService.calculateCards(budgetData);
  }

  private prepareChartsOptions(): void {
    this.chartOptions = BmAnalyticsChartsService.createChartOptions(this.budgetForm.controls.analyticsData);
  }
}
